import { defineStore } from "pinia";
import { writingAssistantConstantes } from "@/constantes/writingAssistant";

export const useWritingAssistantStore = defineStore({
  id: "WritingAssistant",
  state: () => ({
    pausedFields: {},
    infoAutoShown: false,
    infoOpenRequest: 0,
  }),

  actions: {
    pauseField(fieldKey, resetAt = null) {
      const parsed = resetAt ? Date.parse(resetAt) : NaN;
      const resetTimestamp = Number.isNaN(parsed)
        ? Date.now() + writingAssistantConstantes.RESET_DELAY_MINUTES * writingAssistantConstantes.MS_PER_MINUTE
        : parsed;
      this.pausedFields = { ...this.pausedFields, [fieldKey]: resetTimestamp };
    },
    movePause(fromKey, toKey) {
      if (!(fromKey in this.pausedFields)) return;
      const { [fromKey]: resetTimestamp, ...rest } = this.pausedFields;
      this.pausedFields = { ...rest, [toKey]: resetTimestamp };
    },
    resumeField(fieldKey) {
      if (!(fieldKey in this.pausedFields)) return;
      this.pausedFields = Object.fromEntries(Object.entries(this.pausedFields).filter(([key]) => key !== fieldKey));
    },
    requestInfoOpen() {
      if (this.infoAutoShown) return;
      this.infoAutoShown = true;
      this.infoOpenRequest += 1;
    },
    resetInfoAutoShow() {
      this.infoAutoShown = false;
    },
    resumeExpired(now = Date.now()) {
      const entries = Object.entries(this.pausedFields);
      const active = entries.filter(([, resetTimestamp]) => resetTimestamp > now);
      if (active.length !== entries.length) {
        this.pausedFields = Object.fromEntries(active);
      }
    },
  },
});
